export default __webpack_public_path__ + "static/media/miet-healthcare-inc.a9efc78d.png";